import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import Link from '../Link';
import Button from '../Button';
import Icon from '../Icon';
import Form from '../Form';
import Messages from './Messages';
import ConversationMessage from './ConversationMessage';
import s from './ConversationPopup.css';
import Textarea from '../Textarea';
import cx from 'classnames';

class ConversationPopupView extends React.Component {

  state = {
    buttonDisabled: true,
  };
  componentDidMount() {
    const conversationId = this.props.conversationPaging.get('conversationId');
    if (!!conversationId) {
      this.props.getConversation(conversationId);
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.conversation.size !== this.props.conversation.size) {
      this.clearInput();
    }
  }
  componentDidUpdate() {
    this.scrollToLastMessage();
  }
  componentWillUnmount() {
    this.props.resetConversation();
    this.props.resetPaging();
  }
  scrollToLastMessage = () => {
    if (!this.alreadyScrolled) {
      this.messagesBottom.scrollIntoView();
      this.alreadyScrolled = true;
    }
  };
  isMessageOwner = message => message.getIn(['user', 'id']) === this.props.loggedInUserId;
  sendMessage = data => {
    console.log('data', data, this.messageInput.getWrappedInstance());
    const conversationId = this.props.conversationPaging.get('conversationId');
    if (!!conversationId) {
      this.props.sendMessageToConversation(conversationId, data);
    } else {
      const recipient = this.props.conversationPaging.get('recipient');
      this.props.sendMessageToUser(recipient.get('id'), data);
    }
  };
  clearInput = () => {
    this.messageInput.getWrappedInstance().setValue('');
    this.setState({ buttonDisabled: true });
  };
  handleInputChange = event => {
    this.setState({ buttonDisabled: !event.target.value });
  };
  loadPreviousMessages = () => {
    const conversationId = this.props.conversationPaging.get('conversationId');
    this.props.getConversation(conversationId, {
      page: +this.props.conversationPaging.get('currentPage') + 1,
    });
  }
  render() {
    const { producent, conversationPaging }= this.props;
    const messages = Messages();
    const isConversation = !!conversationPaging.get('conversationId');
    const recipient = conversationPaging.get('recipient');
    const conversation = this.props.conversation;
    const hasMore = (conversationPaging.get('itemsPerPage') * conversationPaging.get('currentPage')) < conversationPaging.get('itemsCount');
    const fullName = recipient && recipient.get('full_name');

    const isSuperior = producent === 'spirotech'
    const conversationClose = 
      isSuperior
      ? cx(s.ConversationPopup_close, s.close_spirotech) 
      : cx(s.ConversationPopup_close);

    
    const lightColor = isSuperior ? 'light_spirotech' : 'light';
    const colorStyled = isSuperior ? cx(s.black_text) : cx(s.superior_text);

    return (
      <div className={s.ConversationPopup}>
        <div 
          className={s.ConversationPopup_overlay} 
          onClick={this.props.onClose}
        />
        <div 
          className={s.ConversationPopup_content}>

          <button 
            type="button" 
            className={conversationClose} 
            onClick={this.props.onClose}
            >
            <Icon iconName={"odrzuc"} size={20} />
          </button>

          <section className={cx(s.Box, s.ConversationPopup_box)}>

            <Icon iconName="messages" size={48}/>

            <div className={s.Avatar_container}>
                {isConversation ? (<div className={s.Avatar_text}>
                  <span className="Avatar-teaser ConversationPopup-teaser">
                    <strong>&nbsp;{fullName}&nbsp;</strong>
                    <FormattedMessage {...messages.message_main_title} />
                  </span>
                </div>) :
                (<div className="Avatar-text">
                  <span className="Avatar-teaser ConversationPopup-teaser">
                    <FormattedMessage {...messages.send_new_message_title} />
                    <strong>&nbsp;{fullName}&nbsp;</strong>
                  </span>
                </div>)}
            </div>
            <div className={s.ConversationPopup_message}>
              {hasMore ? <div 
                  className={s.ConversationPopup_loadPrevious} 
                  onClick={this.loadPreviousMessages}>
                  <FormattedMessage {...messages.load_previous_messages} /></div> : null}
              <ul>
              {conversation.map((message, index) =>
                <ConversationMessage
                  message={message}
                  key={message.get('id')}
                  isNew={!this.isMessageOwner(message) && index === conversation.size - 1} />
              )}
              </ul>
              <div ref={el => this.messagesBottom = el}/>
              <Form onSubmit={this.sendMessage}>
                <Textarea
                  name="text"
                  title="add_message_placeholder"
                  className={s.ConversationPopup_textarea}
                  onChange={this.handleInputChange}
                  ref={ref => this.messageInput = ref}/>
                <div className="u-textRight">
                  <Button 
                    buttonColor={lightColor}
                    type="button" 
                    onClick={this.props.onClose}>
                    <div className={colorStyled}>
                      <FormattedMessage id="send_message_skip" />
                    </div>
                  </Button>
                  <Button
                    disabled={this.state.buttonDisabled}
                    buttonColor={lightColor}
                    type="submit">
                    <div className={colorStyled}>
                      <FormattedMessage id="send_message_send" />
                    </div>
                  </Button>
                </div>
              </Form>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

ConversationPopupView.propTypes = {
  conversation: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  conversationPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  loggedInUserId: PropTypes.number.isRequired,
  getConversation: PropTypes.func.isRequired,
  sendMessageToConversation: PropTypes.func.isRequired,
  sendMessageToUser: PropTypes.func.isRequired,
  resetPaging: PropTypes.func.isRequired,
  resetConversation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  producent: PropTypes.string,
};

ConversationPopupView.defaultProps = {
  producent: '',
};

export default withStyles(s)(ConversationPopupView);



// WEBPACK FOOTER //
// ./src/components/ConversationPopup/ConversationPopupView.js